const DB_NAME = "pathfinderQuotationCache";
const STORE_NAME = "specialColorDetails";
const DB_VERSION = 1;

const openSpecialColorDb = () =>
    new Promise((resolve, reject) => {
        if (!window.indexedDB) {
            reject(new Error("IndexedDB is not available"));
            return;
        }

        const request = window.indexedDB.open(DB_NAME, DB_VERSION);

        request.onupgradeneeded = () => {
            const db = request.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: "key" });
            }
        };

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });

const runSpecialColorTransaction = async (mode, callback) => {
    const db = await openSpecialColorDb();

    return new Promise((resolve, reject) => {
        const transaction = db.transaction(STORE_NAME, mode);
        const store = transaction.objectStore(STORE_NAME);
        const request = callback(store);

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
        transaction.oncomplete = () => db.close();
        transaction.onerror = () => {
            db.close();
            reject(transaction.error);
        };
    });
};

export const saveSpecialColorDetail = async (detail) => {
    const key = `${detail?.quotationId || ""}:${detail?.markName || ""}`;

    if (!detail?.quotationId || !detail?.markName) return;

    const existingDetail = await runSpecialColorTransaction("readonly", (store) => store.get(key))
        .catch(() => null);

    await runSpecialColorTransaction("readwrite", (store) =>
        store.put({
            ...(existingDetail || {}),
            ...detail,
            charge: detail?.charge ?? existingDetail?.charge ?? "",
            key,
        })
    );
};

export const getSpecialColorDetails = async (quotationId) => {
    if (!quotationId) return [];

    const allDetails = await runSpecialColorTransaction("readonly", (store) => store.getAll());

    return (allDetails || []).filter(
        (item) => String(item?.quotationId) === String(quotationId)
    );
};
